import { Navigation, Util, CoreContext } from "Core";
import { MenuService, TextBlockService } from "Service";
import { IMenuItem } from "Core/Interfaces";
import { TextBlockCategory } from "Enums";

/**
 * Handles the menu.
 * @hidden
 */
export class Menu {
    private static mapMenuItem(item: IMenuItem, index: number): Object {
        let attr = {};
        if (item.Url) {
            attr["data-dms-menuurl"] = Util.resolve(item.Url, {});
        }
        if (item.UrlMode) {
            attr["data-dms-menumode"] = item.UrlMode;
        }
        if (item.OpenInNewWindow) {
            attr["data-dms-menuopen"] = item.OpenInNewWindow;
        }

        let menuItem: any = {
            text: item.MenuText,
            encoded: false,
            items: item.Items.length > 0 ? $.map(item.Items, Menu.mapMenuItem) : null,
            attr: attr,
        };
        if (item.Icon) {
            if (item.Icon.indexOf(".") > -1) {
                menuItem.imageUrl = CoreContext.Environment.ImagePath + item.Icon;
                menuItem.imageAttr = {
                    width: "20px",
                    height: "20px",
                };
            } else {
                menuItem.spriteCssClass = item.Icon;
            }
        }
        return menuItem;
    }

    /**
     * Initializes the menu.
     */
    public static async initialize(menuService: MenuService, textBlockService: TextBlockService): Promise<void> {
        let menuItems = await menuService.get();

        let mappedItems = $.map(menuItems, this.mapMenuItem);

        new kendo.ui.Menu($(".dms-sidemenu-list")[0], {
            animation: {
                open: {
                    effects: "fadeIn",
                    duration: 100,
                },
            },
            hoverDelay: 100,
            popupCollision: "false",
        });

        $(".dms-sidemenu-container").removeClass("dms-hidden") /*.addClass("animated fadeIn")*/;

        let menuContainer = $(".dms-menu-list");
        new kendo.ui.Menu(menuContainer[0], {
            dataSource: mappedItems,
            animation: {
                open: {
                    effects: "fadeIn",
                    duration: 100,
                },
            },
            popupCollision: "false",
            hoverDelay: 100,
            select: (e: kendo.ui.MenuSelectEvent) => {
                e.preventDefault();

                this.openItem($(e.item));
            },
        });
        $(".dms-menu-container").removeClass("dms-hidden") /*.addClass("animated fadeIn")*/;

        let responsivePanel = new kendo.ui.ResponsivePanel($(".dms-menu")[0], {
            toggleButton: ".dms-menu-toggle",
            orientation: "top",
            breakpoint: 640,
        });

        new kendo.ui.ContextMenu($("<ul/>")[0], {
            target: menuContainer,
            alignToAnchor: false,
            filter: ".k-item",
            open: (e: kendo.ui.ContextMenuOpenEvent) => {
                let item = $(e.target);
                if (item.attr("data-dms-menuurl")) {
                    e.sender.setOptions({
                        dataSource: [
                            {
                                text: textBlockService.get("MenuOpen", TextBlockCategory.global),
                                attr: { "data-dms-mode": "open" },
                            },
                            {
                                text: textBlockService.get("MenuOpenNewWindow", TextBlockCategory.global),
                                attr: { "data-dms-mode": "openNewWindow" },
                            },
                        ],
                    });
                } else {
                    e.preventDefault();
                }
            },
            select: (e: kendo.ui.ContextMenuSelectEvent) => {
                e.preventDefault();
                responsivePanel.close();
                let menuItem = $(e.target);
                let item = $(e.item);
                let mode = item.attr("data-dms-mode");
                if (mode == "open") {
                    this.openItem(menuItem);
                } else if (mode == "openNewWindow") {
                    this.openItem(menuItem, true);
                }
            },
        });
    }

    private static openItem(item: JQuery<Element>, forceNewWindow: boolean = false): void {
        let openInNewWindow = item.attr("data-dms-menuopen") == "true";
        let urlMode = item.attr("data-dms-menumode");
        let url = item.attr("data-dms-menuurl");
        if (url) {
            if (openInNewWindow || forceNewWindow) {
                Navigation.openWindow(url, urlMode);
            } else {
                Navigation.navigate(url);
            }
        }
    }
}
